import { TableCellExpanded, TableRowExpanded } from '@ksyos/design-system';
import { styled } from 'styled-components';
import { renderEmptyCells } from '../../renderEmptyCells';
import { dividerStyling } from './../dividerStyling';

interface FinancingTableActivityHeaderProps {
    heading: string;
    isExpanded: boolean;
}

export function FinancingTableActivityHeader({ isExpanded, heading }: FinancingTableActivityHeaderProps) {
    return (
        <StyledTableRowExpanded isExpanded={isExpanded}>
            {renderEmptyCells(5)}
            <StyledTableCellExpanded
                colSpan={12}
                sx={{ ...dividerStyling, fontSize: 'xs' }}
            >
                {heading}
            </StyledTableCellExpanded>
        </StyledTableRowExpanded>
    );
}

const StyledTableRowExpanded = styled(TableRowExpanded)`
    border-top: ${({ theme }) => `1px solid ${theme.colors.neutral100}`};
    pointer-events: none;
`;

const StyledTableCellExpanded = styled(TableCellExpanded)`
    background-color: ${({ theme }) => theme.colors.neutral100};
`;
